import React, { createContext, useState, useContext, useEffect, useRef } from "react";
import { Toast, Modal, Button } from "react-bootstrap";

const ToastContext = createContext();

export const ToastProvider = ({ children }) => {
  const [toast, setToast] = useState(false);
  const [messageText, setMessageText] = useState("");
  const [toastTop, setToastTop] = useState("12px");
  const [toastType, setToastType] = useState("default");
  const timeoutRef = useRef(null);

  // Confirm modal state
  const [confirm, setConfirm] = useState({
    show: false,
    message: "",
    confirmText: "Да",
    cancelText: "Отмена",
    onConfirm: null,
    onCancel: null,
  });

  const showToast = (message, type = "default") => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }

    setToastType(type);
    setToast(true);
    setMessageText(message);

    timeoutRef.current = setTimeout(() => {
      setToast(false);
    }, 5000);
  };

  const hideToast = () => {
    setToast(false);
  };

  const showConfirm = ({
    message,
    onConfirm,
    onCancel,
    confirmText = "Да",
    cancelText = "Отмена",
  }) => {
    setConfirm({
      show: true,
      message,
      confirmText,
      cancelText,
      onConfirm,
      onCancel,
    });
  };

  const handleConfirm = () => {
    if (confirm.onConfirm) confirm.onConfirm();
    setConfirm((prev) => ({ ...prev, show: false }));
  };

  const handleCancel = () => {
    if (confirm.onCancel) confirm.onCancel();
    setConfirm((prev) => ({ ...prev, show: false }));
  };

  useEffect(() => {
    const handleScroll = () => {
      setToastTop("12px"); // можно адаптировать при желании
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <ToastContext.Provider value={{ showToast, showConfirm }}>
      {children}

      {/* ✅ Toast Message */}
      <Toast
        show={toast}
        className={toastType}
        onClick={hideToast}
        style={{ position: "fixed", top: toastTop, zIndex: 1050 }}
      >
        <Toast.Body>
          <div className="toast-flex">
            <div className="toast-icon me-2">
              {toastType == "default" ? (
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M8.96812 2.82141C9.62395 2.52421 10.3761 2.52421 11.0319 2.82141C11.4971 3.03222 11.8246 3.41875 12.1007 3.82348C12.3753 4.22613 12.6761 4.76759 13.0396 5.42201L16.8805 12.3356C17.2258 12.9571 17.5128 13.4737 17.7016 13.9014C17.8925 14.334 18.0414 14.7981 17.9839 15.29C17.9024 15.988 17.5309 16.6195 16.9603 17.0298C16.5582 17.3188 16.0802 17.4141 15.6093 17.4573C15.1438 17.5 14.5528 17.5 13.8418 17.5H6.15824C5.44721 17.5 4.85627 17.5 4.39074 17.4573C3.91982 17.4141 3.44183 17.3188 3.03977 17.0298C2.46918 16.6195 2.09761 15.988 2.01608 15.29C1.95864 14.7981 2.10749 14.334 2.29844 13.9014C2.48719 13.4737 2.77419 12.9572 3.11951 12.3356L6.9604 5.422C7.32395 4.76758 7.62474 4.22613 7.89936 3.82348C8.17541 3.41875 8.50291 3.03222 8.96812 2.82141ZM10.344 4.33948C10.1254 4.24041 9.87466 4.24041 9.65605 4.33948C9.61969 4.35595 9.50614 4.42555 9.27626 4.76259C9.04997 5.09438 8.78593 5.56792 8.39739 6.26729L4.5961 13.1096C4.22609 13.7756 3.97734 14.2251 3.8232 14.5744C3.66767 14.9267 3.66665 15.0551 3.6715 15.0966C3.69867 15.3293 3.82253 15.5398 4.01273 15.6766C4.04665 15.701 4.1594 15.7624 4.54296 15.7976C4.92312 15.8325 5.43684 15.8333 6.19872 15.8333H13.8013C14.5632 15.8333 15.0769 15.8325 15.4571 15.7976C15.8406 15.7624 15.9534 15.701 15.9873 15.6766C16.1775 15.5398 16.3014 15.3293 16.3285 15.0966C16.3334 15.0551 16.3324 14.9267 16.1768 14.5744C16.0227 14.2251 15.7739 13.7756 15.4039 13.1096L11.6026 6.26729C11.2141 5.56792 10.9501 5.09438 10.7238 4.76259C10.4939 4.42555 10.3803 4.35595 10.344 4.33948ZM10 7.49997C10.4603 7.49997 10.8333 7.87306 10.8333 8.3333V11.6666C10.8333 12.1269 10.4603 12.5 10 12.5C9.53978 12.5 9.16668 12.1269 9.16668 11.6666V8.3333C9.16668 7.87306 9.53978 7.49997 10 7.49997ZM9.16668 14.1666C9.16668 13.7064 9.53978 13.3333 10 13.3333H10.0083C10.4686 13.3333 10.8417 13.7064 10.8417 14.1666C10.8417 14.6269 10.4686 15 10.0083 15H10C9.53978 15 9.16668 14.6269 9.16668 14.1666Z" fill="white"/>
                </svg>
              ):(
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4ZM2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12ZM12 7C12.5523 7 13 7.44772 13 8V13C13 13.5523 12.5523 14 12 14C11.4477 14 11 13.5523 11 13V8C11 7.44772 11.4477 7 12 7ZM11 16C11 15.4477 11.4477 15 12 15H12.01C12.5623 15 13.01 15.4477 13.01 16C13.01 16.5523 12.5623 17 12.01 17H12C11.4477 17 11 16.5523 11 16Z" fill="white"/>
                </svg>
              )}
            </div>
            <div className="toast-text">{messageText}</div>
          </div>
        </Toast.Body>
      </Toast>

      <Modal show={confirm.show} onHide={handleCancel} centered>
        <Modal.Header closeButton style={{borderBottom: "none"}}>
          <Modal.Title>Подтверждение</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{borderBottom: "none"}} >{confirm.message}</Modal.Body>
        <Modal.Footer style={{borderTop: "none"}} className="d-flex flex-nowrap">
          <Button variant="danger" onClick={handleConfirm}>
            {confirm.confirmText}
          </Button>
          <Button variant="secondary" onClick={handleCancel}>
            {confirm.cancelText}
          </Button>
        </Modal.Footer>
      </Modal>
    </ToastContext.Provider>
  );
};

export const useToast = () => useContext(ToastContext);
